import React from 'react'

import styled from 'styled-components'
import * as variables from '../utilities/style-variables'
import bgPatternBlack from "../images/bg_pattern_black.svg"
import bgPatternwhite from "../images/bg_pattern_white.svg"
import { Link } from 'gatsby'

const Form = styled.form `
  padding-bottom: 100px;
  overflow: show;
`

const PatternWrapper = styled.div`
  position: absolute;
  top: 100px;
  display: none;
  flex-direction: column;
  justify-content: space-evenly;
  flex-shrink: 8;

  &.left {
    left: 50px;
  }
  &.right {
    right: 50px;
  }

  @media (min-width: 768px) { // Medium devices (tablets, 768px and up)
    display: flex;
    top: 200px;

    &.left {
      left: 0px;
    }
    &.right {
      right: 0px;
    }
  }

  @media (min-width: 1200px) { // X-Large devices (large desktops, 1200px and up)
    &.left {
      left: 50px;
    }
    &.right {
      right: 50px;
    }
  }
`

const Pattern = styled.div`
  width: 50px;
  height: 400px;
  transform: rotate(20deg);
  background-repeat: no-repeat;
  background-size: contain;
  z-index: -1;

  &.black {
    background-image: url(${bgPatternBlack});
  }
  &.white {
    background-image: url(${bgPatternwhite});
  }
  &:nth-child(n+2) {
    margin-top:-180px;
  }

  @media (min-width: 768px) { // Medium devices (tablets, 768px and up)
    width: 40px;
    height: 240px;

    &:nth-child(n+2) {
    margin-top: -60px;
    }
  } 

  @media (min-width: 992px) { // Large devices (desktops, 992px and up)
    width: 50px;
    height: 400px;  
    
    &:nth-child(n+2) {
      margin-top: -100px;
    }
  }

  @media (min-width: 1200px) { // X-Large devices (large desktops, 1200px and up)
    width: 60px;
    height: 500px;
  }
`


const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  @media (min-width: 992px) { // Large devices (desktops, 992px and up)
    flex-direction: row;
    width: 80%;
    margin: 0 auto;
  }
`

const FormContainer = styled.div`
  margin: 0 auto;
  width: 80%;

  @media (min-width: 768px) { // Medium devices (tablets, 768px and up)
    width: 80%;
  } 

  @media (min-width: 992px) { // Large devices (desktops, 992px and up)
    margin: 0 auto;
    padding: 0 20px;
    width: 80%;       
  }
`

const FormGroup = styled.div`
  width: 100%;
  position: relative;
  margin: 20px auto;

  &:hover,
  &:focus-within {
      border-color: ${variables.brand_secondary};
  }

  &:hover input {
    color: ${variables.brand_secondary};
  }

  &:focus-within label {
    font-size: 12px;
    padding: 0px;
    top: -12px;
    left: 10px;
    bottom: auto;
    color: ${variables.black};
  }

  @media (min-width: 992px) { // Large devices (desktops, 992px and up)
    max-width: 400px;
  }
`

const Input = styled.input`
  width: 100%;
  padding: 10px 10px;
  color: ${variables.black};
  font-size: ${variables.font_size__desktop_text};
  border: none;
  background-color: transparent;
  border-bottom: 3px solid ${variables.black};

  &:focus {
    color: inherit!important;
    outline: none;
  }

  &:not(:placeholder-shown) {
    border-bottom: 3px solid ${variables.brand_secondary};
  }

  &:not(:placeholder-shown) ~ label{
    font-size: 12px;
    padding: 0px;
    top: -12px;
    left: 10px;
    bottom: auto;
    color: ${variables.black};
  }
`

const Label = styled.label`
  position: absolute;
  background-color: transparent;
  padding: 10px 0;
  line-height: 20px;
  top: 0;
  left: 10px;
  bottom: 0;
  color: ${variables.black};
  cursor: text;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${variables.brand_secondary};
  }

  span {
    padding-left: 5px;
    font-size: 0.6em;
  }
`

const Textarea = styled.textarea`
  width: 100%;
  height: 190px !important;
  padding: 10px 10px;
  color: ${variables.black};
  font-size: ${variables.font_size__desktop_text};
  line-height: 20px;
  border: none;
  background-color: transparent;
  border-bottom: 3px solid ${variables.black};
  resize: none;

  &:focus {
    color: inherit !important;
    outline: none;
  }

  &:not(:placeholder-shown) {
    border-bottom: 3px solid ${variables.brand_secondary};
  }

  &:not(:placeholder-shown) ~ label{
    font-size: 12px;
    padding: 0px;
    top: -12px;
    left: 10px;
    bottom: auto;
    color: ${variables.black};
  }
`

const TextareaLabel = styled.label `
  position: absolute;
  background-color: transparent;
  padding: 10px 0;
  line-height: 20px;
  top: 0;
  left: 10px;
  bottom: 0;
  z-index:-1;
  color: ${variables.black};
  cursor: text;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${variables.brand_secondary};
  }
`

const CheckboxWrapper = styled.div `
  width: 80%;
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;

  @media (min-width: 992px) { // Large devices (desktops, 992px and up)
    justify-content: center;
  }
`

const Checkbox = styled.input `
  display: inline-block;
  margin-right: 10px;
  width: 45px;
`

const CheckboxLabel = styled.label `
  display: inline;
  font-size: 0.9em;

  a {
    font-family: ${variables.text_font};
    font-size: inherit;
    text-decoration: underline;
    color: inherit;

    &:hover {
        color: inherit;
    }
  }
`

const SubmitButton = styled.input `
  position: relative;
  display: block;
  width: 80%;
  margin: 20px auto;
  padding: 5px 15px;
  background-color: ${variables.brand_cta};
  color: ${variables.brand_primary};
  border-width: 3px;
  border-color: ${variables.brand_cta};
  text-transform: uppercase;
  border-style: solid;
  transition: all ease-in-out 300ms;

  &:hover {
    background-color: ${variables.brand_primary};
    color: ${variables.brand_cta};
  }

  @media (min-width: 992px) { // Large devices (desktops, 992px and up)
    margin-top: 50px;
    width: auto;
  }
`

const ContactForm = () => {

  const handleSubmit=()=>{ 
    window.dataLayer.push({event: "form_submit"});
  }

  return (
    <>
      <Form
        method="post" 
        netlify-honeypot="bot-field" 
        data-netlify="true" 
        name="contact" 
        action="/danke"
        onSubmit={handleSubmit}
        >
        <input type="hidden" name="bot-field" />
        <input type="hidden" name="form-name" value="contact" />

        <PatternWrapper className='left'>
          <Pattern className="black"></Pattern>
          <Pattern className="white"></Pattern>
          <Pattern className="black"></Pattern>
        </PatternWrapper>
        
        <PatternWrapper className='right'>
          <Pattern className="white"></Pattern>
          <Pattern className="black"></Pattern>          
        </PatternWrapper>        

        <FormWrapper>
          <FormContainer>
            <FormGroup>
              <Input name="name" type="text" required id="name" placeholder=" "></Input>
              <Label htmlFor="name" className="control-label">Name</Label>
              
            </FormGroup>

            <FormGroup>
              <Input name="company" type="text" id="company" placeholder=" "></Input>
              <Label htmlFor="company" className="control-label">Firmenname <span>(optional)</span></Label>
            </FormGroup>

            <FormGroup>
              <Input name="email" type="email" required id="email" placeholder=" " pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"></Input>
              <Label htmlFor="email" className="control-label">E-Mail</Label>
            </FormGroup>
          </FormContainer>
          
          <FormContainer>
            <FormGroup>
              <Textarea name="message" id="nachricht" required placeholder=" "></Textarea>
              <TextareaLabel htmlFor="nachricht" className="control-label">Deine Nachricht</TextareaLabel>
            </FormGroup>
          </FormContainer>
        </FormWrapper>

        <CheckboxWrapper>
          <Checkbox type="checkbox" id="form-checkbox" required></Checkbox>
          <CheckboxLabel htmlFor="form-checkbox">
            Ich stimme zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden. 
            Die <Link to="/datenschutz">Datenschutzerklärung</Link> habe ich zur Kenntnis genommen.</CheckboxLabel>
        </CheckboxWrapper>

        <SubmitButton
          type="submit"
          value="Nachricht abschicken"
          form="contact-form"
        ></SubmitButton>

        
      </Form>
    </>
  )
}

export default ContactForm